<div class="backpage-wrapper">
  <div class="cred-library-content-creator">
    <!-- <ng-container
        *ngIf="
          (!hasCompany && isTechSupportInternalUser) ||
          isInternalAdminUser ||
          (hasCompany && !isTechSupportExternalUser)
        " -->
    <ng-container>
      <div class="credential-library-container padding s6 all">
        <div class="header">
          <h1>Available Subscriptions</h1>
        </div>
        <div class="avail-subs-container padding s6 all">
          <div class="avail-item-container">
            <a class="clickable-card" routerLink="/nfc-mobile-credentials">
              <phx-card class="left-side-card padding s6 all">
                <!-- <img
                  width="75"
                  height="75"
                  src="../../../assets/Logos/IQ toolbox logo.png"
                  alt="credential logo"
                /> -->
                <img
                  width="75"
                  height="75"
                  src="../../../assets/Logos/zentra_logo-removebg-preview 1.png"
                  alt="zentra green logo"
                />
                <h2>Zentra Subscriptions</h2>
              </phx-card>
            </a>
            <div class="view-info-button-container padding s6 all">
              <button
                mat-raised-button
                class="custom-view-info-button"
                (click)="toggleStanleyDetails()"
              >
                {{ showDetails ? "Less Details" : "More Details" }}
              </button>
              <button
                mat-raised-button
                class="custom-view-info-button"
                (click)="purchaseSubscription()"
                routerLink="/subscriptions-landing"
              >
                <span>Purchase Subscription</span>
              </button>
            </div>

            <div *ngIf="showDetails" class="details-container padding s6 all">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                odio diam, posuere aliquam est vitae, lacinia ullamcorper quam.
                Nunc commodo quam ut purus cursus, nec pharetra ante pulvinar.
                Vivamus at sodales neque, et tempus risus. Vestibulum ac aliquam
                ex. Duis vel ipsum eu odio feugiat venenatis. Cras vel laoreet
                ipsum. Phasellus at ultrices risus. Nullam blandit massa at nunc
                vehicula, faucibus laoreet nisl imperdiet. Duis vehicula est ut
                ullamcorper porttitor. Etiam faucibus eleifend magna ac
                lobortis. Aliquam iaculis libero sed lacus sodales, non
                efficitur mi commodo. Aliquam volutpat velit sit amet elit
                vulputate ultrices. Donec in ultricies nulla.
              </p>
            </div>
          </div>
        </div>
        <div class="cred-item-container" *ifPermissions="['']">
          <phx-card class="left-side-card padding s6 all">
            <img
              width="75"
              height="75"
              src="../../../assets/weDraw-Images/undraw_notify_re_65on.svg"
              alt="orange explanation point"
            />
            <h2>No Available Subscriptions Found</h2>
          </phx-card>
          <div class="view-info-button-container padding s6 all"></div>
        </div>
      </div>
    </ng-container>

    <!-- <ng-container> -->
    <!-- <ng-container *ngIf="isTechSupportExternalUser"> -->
    <!-- <div class="external-role-error-container padding s6 all">
        <phx-card class="left-side-card padding s6 all">
          <img
            width="75"
            height="75"
            src="../../../assets/weDraw-Images/undraw_notify_re_65on.svg"
            alt="orange explanation point"
          />
          <h2>
            Your account is not tied to an external role - contact
            <a href="mailto:mobilecredentials@allegion.com"
              >mobilecredentials&#64;allegion.com</a
            >
            and Allegion will help you complete setup.
          </h2>
        </phx-card>
        <div class="view-info-button-container padding s6 all"></div>
      </div>
    </ng-container> -->
    <!-- <ng-container>
      <div class="external-role-error-container padding s6 all">
        <phx-card class="left-side-card padding s6 all">
          <img
            width="75"
            height="75"
            src="../../../assets/weDraw-Images/undraw_notify_re_65on.svg"
            alt="orange explanation point"
          />
          <h2>
            Your account is not tied to a valid company - contact
            <a href="mailto:mobilecredentials@allegion.com"
              >mobilecredentials&#64;allegion.com</a
            >
            and Allegion will help you complete setup.
          </h2>
        </phx-card>
        <div class="view-info-button-container padding s6 all"></div>
      </div>
    </ng-container> -->
  </div>
</div>
